import {Component, Input} from '@angular/core';

/**
 * @param color : ['primary', 'accent', 'warn']
 */
@Component({
  selector: 'nc-button',
  templateUrl: './nc-button.component.html',
  styleUrls: ['./nc-button.component.scss']
})
export class NcButtonComponent {
  @Input() isRaised: boolean = true;
  @Input() label: string;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() disabled: boolean = null;
  @Input() visible: boolean = true;
  @Input() onClick: () => void;
  @Input() icon: string;
  @Input() id: string;

  constructor() {
  }
}
